// AUTH REDUCER
export const SP_SIGN_OUT = "SP_SIGN_OUT";
export const SP_SIGN_IN = "SP_SIGN_IN";
export const SP_TOGGLE_LOADING = "SP_TOGGLE_LOADING";
export const SP_CHANGE_ROUTE = "SP_CHANGE_ROUTE";
export const SP_CHANGE_COMPANY = "SP_CHANGE_COMPANY";
export const SP_ADD_COMPANY_LIST = "SP_ADD_COMPANY_LIST";
export const SP_ADD_MENU_LIST = "SP_ADD_MENU_LIST";
export const SP_USER_ROLE = "SP_USER_ROLE";
export const SP_ADD_USER_BRANCH_LIST = "SP_ADD_USER_BRANCH_LIST";
export const SP_SET_COLLAPSABLE = "SP_SET_COLLAPSABLE";
export const SP_SET_AUTH_STATE = "SP_SET_AUTH_STATE";
export const SP_SET_DAY_SHIFT_TERMINAL_MODAL =
  "SP_SET_DAY_SHIFT_TERMINAL_MODAL";

// POINT OF SALE REDUCER
export const SP_SET_SALE_RETURN_STATE = "SP_SET_SALE_RETURN_STATE";
export const SP_SALE_RETURN_MODE = "SP_SALE_RETURN_MODE";
export const SP_CLOSE_SALE_RETURN_MODE = "SP_CLOSE_SALE_RETURN_MODE";
export const SP_OPEN_ORDER_MODE = "SP_OPEN_ORDER_MODE";
export const SP_OPEN_CUSTOMER_TABLE = "SP_OPEN_CUSTOMER_TABLE";
export const SP_OPEN_CUSTOMER = "SP_OPEN_CUSTOMER";
export const SP_OPEN_PUNCH = "SP_OPEN_PUNCH";
export const SP_CLOSE_DRAWERS = "SP_CLOSE_DRAWERS";
export const SP_OPEN_PRODUCT = "SP_OPEN_PRODUCT";
export const SP_SET_POS_STATE = "SP_SET_POS_STATE";
export const SP_SET_CUSTOMER_DETAIL = "SP_SET_CUSTOMER_DETAIL";
export const SP_SET_CUSTOMER_SUPPORTING_TABLE =
  "SP_SET_CUSTOMER_SUPPORTING_TABLE";
export const SP_SET_CUSTOMER_SUPPORTING_SINGLE_TABLE =
  "SP_SET_CUSTOMER_SUPPORTING_SINGLE_TABLE";
export const SP_ADD_TO_CART = "SP_ADD_TO_CART";
export const SP_RESET_DEFAULT_POS_STATE = "SP_RESET_DEFAULT_POS_STATE";
export const SP_SET_RECALL_ORDER = "SP_SET_RECALL_ORDER";
export const SP_UPDATE_PRODUCT_CART = "SP_UPDATE_PRODUCT_CART";
export const SP_SET_REPORTS_DATA = "SP_SET_REPORTS_DATA";
export const SP_SET_REPORTS_LOADING = "SP_SET_REPORTS_LOADING";
export const SP_SET_BRANCHES_LOADING = "SP_SET_BRANCHES_LOADING";
export const SP_SET_BRANCHES = "SP_SET_BRANCHES";
export const SP_SET_SUPP_TABLE_REPORT = "SP_SET_SUPP_TABLE_REPORT";
export const SP_SET_REPORT_VIEW_LOADING = "SP_SET_REPORT_VIEW_LOADING";
export const SP_SET_REPORT_VIEW_DATA = "SP_SET_REPORT_VIEW_DATA";
export const SP_SET_REPORT_VIEW_DATA_SUPPORTING_TABLE =
  "SP_SET_REPORT_VIEW_DATA_SUPPORTING_TABLE";
export const SP_SET_CART_RANDOM_ID_STATE = "SP_SET_CART_RANDOM_ID_STATE";
export const SP_TOGGLE_ORDER_DETAIL = "SP_TOGGLE_ORDER_DETAIL";
export const SP_SET_GST = "SP_SET_GST";
export const SP_SET_GST_AMOUNT = "SP_SET_GST_AMOUNT";
export const SP_SET_ORDER_MODE_LIST = "SP_SET_ORDER_MODE_LIST";
export const SP_SET_ORDER_SOURCE_LIST = "SP_SET_ORDER_SOURCE_LIST";
export const SP_SET_HOLD_ORDER = "SP_SET_HOLD_ORDER";
export const SP_SET_ORDER_SOURCE = "SP_SET_ORDER_SOURCE";
export const SP_SET_PRINTING_TEMPLATE = "SP_SET_PRINTING_TEMPLATE";
export const SP_SET_ORDER_MODE = "SP_SET_ORDER_MODE";
